/// <reference types="facebook-pixel" />
import csrfPost from '../../helpers/csrfPost'
import { requestUUID } from './helpers'

type AddedProduct = {
  name: string
  sku: string
}

export const trackFacebookAddToCart = (products: AddedProduct[]): void => {
  if (products.length === 0) {
    return
  }

  let parameters: facebook.Pixel.AddToCartParameters = {
    content_type: 'product',
    content_ids: products.map(product => product.sku)
  }

  if (products.length === 1) {
    parameters.content_name = products[0].name
  }

  const eventID = requestUUID() + '-' + performance.now().toString()

  if (typeof fbq !== 'undefined') {
    fbq('track', 'AddToCart', parameters, { eventID })
  }

  csrfPost('/basket/add_to_cart', { products, event_id: eventID })
}
